export default "/_next/static/images/a1d100552820f81d9b69273da08abcae.png";